import React, { useState } from "react";
import "./index.scss";
import { Table, Typography } from "antd";
import ProductDefaultImage from "@assets/images/product-default.png";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import moment from "moment";

import { DATE_TIME_FORMAT } from "@config/constants";
import { getBidHistoryQuery } from "dataLayer/user";

const { Title, Text } = Typography;
const pageSize = 10;
const pagination = {
  position: "bottomRight",
  className: "account-product-pagination",
  showQuickJumper: false,
  showSizeChanger: false,
  hideOnSinglePage: true,
  showTitle: false,
  size: "small",
  defaultCurrent: 1,
  pageSize,
};

const AccountBidHistory = () => {
  const [curPage, setCurPage] = useState(1);
  const { t } = useTranslation();
  const { data: bidHistories, isLoading } = useQuery(
    getBidHistoryQuery(curPage, pageSize)
  );

  const handleTableChange = (pagination, filters, sorter) => {
    setCurPage(pagination.current);
  };

  const BID_HISTORY_STATUS = {
    SUCCESS: t("account.bid_history_page.status_success"),
    FAIL: t("account.bid_history_page.status_fail"),
    0: t("account.bid_history_page.status_success"),
  };

  const columns = [
    {
      title: t("account.bid_history_page.product"),
      dataIndex: "product_name",
      filterMode: "tree",
      filterSearch: true,
      onFilter: (value, record) => record.product.includes(value),
      render: (_, record) => (
        <div className="account-product">
          <div
            className="account-product-image"
            style={{
              backgroundImage: `url(${
                record.product_image?.split(",")[0] || ProductDefaultImage
              })`,
            }}
          />
          <Text className="account-product-title">{record.product_name}</Text>
        </div>
      ),
      width: "25%",
    },
    {
      title: t("account.bid_history_page.product_code"),
      dataIndex: "product_code",
      filterSearch: true,
      align: "center",
      className: "align-middle",
      render: (text) => <Text className="account-product-title">{text}</Text>,
      width: "15%",
    },
    {
      title: t("account.bid_history_page.market_price"),
      dataIndex: "product_price",
      align: "center",
      className: "align-middle",
      render: (text) => (
        <Text className="account-product-price">
          {t("currency_sign")} {text}
        </Text>
      ),
      // sorter: (a, b) => a.product_price - b.product_price,
      width: "15%",
    },
    {
      title: t("account.bid_history_page.bid_price"),
      dataIndex: "price",
      align: "center",
      className: "align-middle",
      render: (text) => (
        <Text className="account-product-price">
          {t("currency_sign")} {text}
        </Text>
      ),
      // sorter: (a, b) => a.price - b.price,
      width: "15%",
    },
    {
      title: t("account.bid_history_page.bid_time"),
      dataIndex: "auction_time",
      align: "center",
      className: "align-middle",
      render: (text) => (
        <Text className="account-product-time">
          {moment(text).format(DATE_TIME_FORMAT)}
        </Text>
      ),
      width: "20%",
    },
    {
      title: t("account.bid_history_page.status"),
      dataIndex: "status",
      align: "center",
      className: "align-middle",
      // filters: [
      //   {
      //     text: t("account.bid_history_page.status_success"),
      //     value: 0,
      //   },
      //   {
      //     text: t("account.bid_history_page.status_fail"),
      //     value: -1,
      //   }
      // ],
      onFilter: (value, record) =>
        BID_HISTORY_STATUS[value] === BID_HISTORY_STATUS.SUCCESS,
      render: (text) => (
        <Text
          className={`account-product-status  ${
            BID_HISTORY_STATUS[text] === BID_HISTORY_STATUS.SUCCESS
              ? "success"
              : "fail"
          }`}>
          {BID_HISTORY_STATUS[text] || BID_HISTORY_STATUS.FAIL}
        </Text>
      ),
      filterSearch: true,
      width: "10%",
    },
    // {
    //   title: '',
    //   dataIndex: '',
    //   align: 'center',
    //   className: 'align-middle',
    //   render: () => <Button className="account-product-button">More Info</Button>,
    //   width: '10%',
    // },
  ];

  return (
    <div className="account-bit-history">
      <Title level={2} className="account-page-title">
        {t("account.bid_history")}
      </Title>
      <Table
        className="account-table"
        rowKey={(record) => record.bid_time}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={{ ...pagination, total: bidHistories?.total }}
        columns={columns}
        dataSource={bidHistories?.data}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default AccountBidHistory;
